import { render, staticRenderFns } from "./featuresProject.vue?vue&type=template&id=7bba7117&scoped=true"
import script from "./featuresProject.vue?vue&type=script&lang=js"
export * from "./featuresProject.vue?vue&type=script&lang=js"
import style0 from "./featuresProject.vue?vue&type=style&index=0&id=7bba7117&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bba7117",
  null
  
)

export default component.exports